import { render } from "./select.vue?vue&type=template&id=133eec6f&scoped=true&ts=true"
import script from "./select.vue?vue&type=script&lang=ts"
export * from "./select.vue?vue&type=script&lang=ts"

import "./select.vue?vue&type=style&index=0&id=133eec6f&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133eec6f"]])

export default __exports__